/* ค่าคงที่ของ RC (ต้องตรงกับ api/common/file-lib.php) */
import React from "react";
import { Tag } from "antd";

export const RC_TYPES = ["งานลด/งานเพิ่ม", "แก้ไขแบบ", "อื่นๆ"];
export const RC_STATUS = ["รอรับเรื่อง", "รับเรื่องแล้ว", "อนุมัติ", "ไม่อนุมัติ", "เสร็จสิ้น", "ยกเลิก"];
export const RC_CLOSED = ["ไม่อนุมัติ", "เสร็จสิ้น", "ยกเลิก"];

export const RC_TYPE_HINT = {
  "งานลด/งานเพิ่ม": "เพิ่มหรือลดรายการงาน เช่น เพิ่มปลั๊ก ลดงานรั้ว เปลี่ยนวัสดุ",
  แก้ไขแบบ: "ปรับแบบบ้าน เช่น ขยายห้อง ย้ายประตู/หน้าต่าง",
  อื่นๆ: "เรื่องอื่น ๆ ที่ต้องการแจ้งทีมงาน",
};

const STATUS_COLOR = {
  รอรับเรื่อง: "orange",
  รับเรื่องแล้ว: "blue",
  อนุมัติ: "green",
  ไม่อนุมัติ: "red",
  เสร็จสิ้น: "cyan",
  ยกเลิก: "default",
};
const TYPE_COLOR = { "งานลด/งานเพิ่ม": "gold", แก้ไขแบบ: "purple", อื่นๆ: "default" };

export const RcStatusTag = ({ value }) => <Tag color={STATUS_COLOR[value] || "default"}>{value || "-"}</Tag>;
export const RcTypeTag = ({ value }) => (
  <Tag color={TYPE_COLOR[value] || "default"} bordered={false}>
    {value}
  </Tag>
);

/* ยอดเงิน + = งานเพิ่ม , - = งานลด */
export const costText = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  const s = Math.abs(n).toLocaleString("th-TH", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return n > 0 ? `+${s} บาท` : n < 0 ? `-${s} บาท` : "0 บาท";
};
